<template>
    <app-layout title="Rollen">
        <template #header>
            <page-title :title="'Rollen - ' + role .name" />
        </template>

        <template #pageContent>

        <div class="text-center" v-if="role.deleted_at">
            <Button
                buttonClass="redo"
                title="Rol herstellen"
                text="Rol herstellen"
                @click="restoreRole"
            />
        </div>
        <div class="text-center" v-else>
            <Button
                htmlType="a"
                buttonClass="edit"
                title="Rol wijzigen"
                text="Rol wijzigen"
                :href="route('admin.roles.edit', {'id':role.id})"
            />
            <Button
                buttonClass="delete"
                title="Rol verwijderen"
                text="Rol verwijderen"
                @click="deleteRole"
            />
        </div>
        <div id="info" class="border-solid border border-slate-300 rounded m-4">
            <div class="border-solid border-b border-slate-300 bg-gray-100">
                <p class="pt-2 pl-2">Algemene informatie</p>
            </div>
            <div class="mt-1">
                <div class="m-4">
                    <div class="flex">
                        <p class="w-1/4 text-left font-bold">Rol ID</p>
                        <p class="w-3/4 text-left">{{ role.id }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Naam</p>
                        <p class="w-3/4 text-left">{{ role.name }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Omschrijving</p>
                        <p class="w-3/4 text-left">{{ role.description }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Slug</p>
                        <p class="w-3/4 text-left">{{ role.slug }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Niveau</p>
                        <p class="w-3/4 text-left">{{ role.level }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Overerfbaar</p>
                        <p class="w-3/4 text-left">{{ role.inheritable }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Aangemaakt op</p>
                        <p class="w-3/4 text-left">{{ moment(role.created_at).format('DD/MM/YYYY HH:mm') }}</p>
                    </div>
                    <div class="flex border-t pt-1">
                        <p class="w-1/4 text-left font-bold">Gewijzigd op</p>
                        <p class="w-3/4 text-left">{{ moment(role.updated_at).format('DD/MM/YYYY HH:mm') }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div id="roles" class="border-solid border border-slate-300 rounded m-4">
            <div class="border-solid border-b border-slate-300 bg-gray-100">
                <p class="pt-2 pl-2">Afdelingen en Rechten</p>
            </div>
            <div class="m-4">
                <div class="flex">
                    <p class="w-1/4 font-bold">Afdelingen</p>
                    <div class="w-3/4">
                        <template v-for="department in role.departments">
                            <badge :text="department.department" badgeClass="light" class="text-sm"/>
                        </template>
                    </div>
                </div>
                <div class="flex border-t pt-1">
                    <p class="w-1/4 font-bold">Rechten</p>
                    <div class="w-3/4">
                        <badge v-for="permission in role.permissions" :text="permission.name" badgeClass="light" class="text-sm"/>
                    </div>
                </div>
            </div>
        </div>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Td from '@/Components/Td.vue'
import Th from '@/Components/Th.vue'
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Input from '@/Components/Input.vue'
import Badge from '@/Components/Badge.vue'
import Select from '@/Components/Select.vue'
import Form from '@/Components/Form.vue'

import { Link } from '@inertiajs/inertia-vue3';
import store from '@/store'
import moment from "moment";
import { Inertia } from "@inertiajs/inertia"

export default {
    components: {
        AppLayout,
        PageTitle,
        Link, Table,
        Td,
        Th,
        Button,
        Modal,
        Input,
        Badge,
        Select,
        Form
    },
    props:[
        'role'
    ],
    data() {
        return {}
    },
    setup (props){
        function deleteRole(){
            if(confirm('Rol \'' + props.role.name + '\' wissen?')){
                Inertia.delete('/admin/roles/' + props.role.id)
            }
        }
        function restoreRole(){
            if(confirm('Rol \'' + props.role.name + '\' herstellen?')){
                Inertia.put('/admin/roles/' + props.role.id + '/restore')
            }
        }
        return {
            state: store.state,
            ...store,
            deleteRole,
            restoreRole
        }
    },
    created: function () {
        this.moment = moment;
    },
    computed: {
    },
}

</script>
